import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import * as React from 'react';

import { cn } from '@lib/utils';

const Checkbox = (props: React.ComponentProps<typeof CheckboxPrimitive.Root>) => {
  const { className, ...otherProps } = props;

  return (
    <CheckboxPrimitive.Root
      className={cn(
        'grid h-4 w-4 shrink-0 place-content-center rounded-sm border border-gray-300',
        'peer ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-70',
        'data-[state=checked]:border-[#3D2EFF] data-[state=checked]:bg-[#3D2EFF] data-[state=checked]:text-white',
        className,
      )}
      {...otherProps}
    >
      <CheckboxPrimitive.Indicator className={cn('grid place-content-center text-current')}>
        <Check className="h-4 w-4" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
};
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
